
<h2>עושה גלים- הודעת מערכת</h2>
<mat-dialog-content class="dialog">
    <h3>קמפיין נוצר בהצלחה!</h3>
    <div class="conteiner">
        <div class="item">
            <h3>
                <p>
                    מזהה קמפיין: {{data.campaign.id}}
                    <button mat-mini-fab color="primary" [cdkCopyToClipboard]="data.campaign.id"
                        (click)="queryIdCopy()" class="actionBtn" aria-label="copy to clipbord">
                        <mat-icon>content_copy</mat-icon>
                    </button>
                </p>
            </h3>
        </div>
        <div class="item">
            <mat-icon class="v-icon">check_circle_outline</mat-icon>
        </div>
    </div>

</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false">סגור</button>
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>עבור לקמפיינים</button>
</mat-dialog-actions>